"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.split = exports.getAccounts = exports.verifyMessageHash = exports.computeAddress = exports.diff = void 0;
const fast_deep_equal_1 = __importDefault(require("fast-deep-equal"));
const starknet_1 = require("starknet");
const constants_1 = require("./constants");
const cbor_x_1 = require("cbor-x");
function diff(a, b) {
    return a.reduce((prev, policyA) => b.some((policyB) => (0, fast_deep_equal_1.default)(policyB, policyA)) ? prev : [...prev, policyA], []);
}
exports.diff = diff;
const computeAddress = (username, { x0, x1, x2 }, { y0, y1, y2 }, deviceKey) => starknet_1.hash.calculateContractAddressFromHash(starknet_1.shortString.encodeShortString(username), starknet_1.number.toBN(constants_1.PROXY_CLASS), [
    starknet_1.number.toBN(constants_1.CLASS_HASHES["0.0.1"].account),
    starknet_1.hash.getSelectorFromName("initialize"),
    "9",
    starknet_1.number.toBN(constants_1.CLASS_HASHES["0.0.1"].controller),
    "7",
    x0,
    x1,
    x2,
    y0,
    y1,
    y2,
    starknet_1.number.toBN(deviceKey),
], "0");
exports.computeAddress = computeAddress;
const verifyMessageHash = (provider, address, messageHash, signature) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b, _c;
    const isDeployed = !!provider.getClassHashAt(address, "latest");
    if (isDeployed) {
        const res = yield provider.callContract({
            contractAddress: address,
            entrypoint: "executeOnPlugin",
            calldata: [
                constants_1.CLASS_HASHES["0.0.1"].controller,
                starknet_1.hash.getSelector("is_public_key"),
                "0x1",
                signature[0],
            ],
        });
        const isRegistered = (res === null || res === void 0 ? void 0 : res.result[0]) === "0x1";
        if (isRegistered) {
            const keyPair = starknet_1.ec.getKeyPairFromPublicKey(signature[0]);
            return starknet_1.ec.verify(keyPair, starknet_1.number.toBN(messageHash).toString(), signature);
        }
        else {
            const res = yield provider.callContract({
                contractAddress: address,
                entrypoint: "isValidSignature",
                calldata: [messageHash, signature.length, ...signature],
            }, "latest");
            return (res === null || res === void 0 ? void 0 : res.result[0]) === "0x1";
        }
    }
    else {
        const res = yield (yield fetch("https://api.cartridge.gg/query", {
            "headers": {
                "content-type": "application/json",
            },
            "body": `{\"query\":\"query Account($address: String!) {\\n  accounts(where: { contractAddress: $address }) {\\n    edges {\\n      node {\\n        id\\n        credential {\\n          id\\n          publicKey\\n        }\\n      }\\n    }\\n  }\\n}\\n\",\"variables\":{\"address\":\"${(0, starknet_1.addAddressPadding)(address)}\"},\"operationName\":\"Account\"}`,
            "method": "POST",
            "mode": "cors",
            "credentials": "omit",
        })).json();
        const account = (_c = (_b = (_a = res === null || res === void 0 ? void 0 : res.accounts) === null || _a === void 0 ? void 0 : _a.edges) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.node;
        if (!account) {
            return false;
        }
        const pubKeyCbor = (0, cbor_x_1.decode)(starknet_1.number.toBN(account.credential.publicKey).toBuffer())[0];
        const x = starknet_1.number.toBN("0x" + pubKeyCbor[-2].toString("hex"));
        const y = starknet_1.number.toBN("0x" + pubKeyCbor[-3].toString("hex"));
        const { x: x0, y: x1, z: x2 } = split(x);
        const { x: y0, y: y1, z: y2 } = split(y);
        const computedAddress = (0, exports.computeAddress)(account.id, { x0, x1, x2 }, { y0, y1, y2 }, signature[0]);
        if (computedAddress !== address) {
            throw new Error("invalid public key");
        }
        const keyPair = starknet_1.ec.getKeyPairFromPublicKey(signature[0]);
        return starknet_1.ec.verify(keyPair, starknet_1.number.toBN(messageHash).toString(), signature);
    }
});
exports.verifyMessageHash = verifyMessageHash;
const getAccounts = (addresses) => __awaiter(void 0, void 0, void 0, function* () {
    const query = addresses.map(addr => ({
        contractAddress: (0, starknet_1.addAddressPadding)(addr),
    }));
    const res = yield (yield fetch("https://api.cartridge.gg/query", {
        "headers": {
            "content-type": "application/json",
        },
        "body": `{\"query\":\"query AccountInfo($addresses: [AccountWhereInput!]!) {\\n  accounts(where: { or: $addresses}) {\\n    edges {\\n      node {\\n        id\\n  contractAddress\\n      }\\n    }\\n  }\\n}\",\"variables\":{\"addresses\":${JSON.stringify(query)}},\"operationName\":\"AccountInfo\"}`,
        "method": "POST",
        "mode": "cors",
        "credentials": "omit"
    })).json();
    if (res.errors) {
        throw new Error(res.errors[0].message);
    }
    return res.accounts.edges.map((edge) => ({
        id: edge.node.id,
        name: edge.node.id,
        profile_uri: `https://cartridge.gg/profile/${edge.node.contractAddress}`,
    }));
});
exports.getAccounts = getAccounts;
const BASE = starknet_1.number.toBN(2).pow(starknet_1.number.toBN(86));
function split(n) {
    const x = n.mod(BASE);
    const y = n.div(BASE).mod(BASE);
    const z = n.div(BASE).div(BASE);
    return { x, y, z };
}
exports.split = split;
//# sourceMappingURL=utils.js.map